import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const ALLOWED_EMAIL_DOMAINS = [
  'gmail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'yahoo.com',
  'yahoo.com.vn',
  'icloud.com',
  'protonmail.com',
];

@Injectable({
  providedIn: 'root',
})
export class AuthValidator {
  constructor() {}

  emailDomainValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value as string;
      if (!value) return null; // email is optional on frontend (backend enforces for email provider)
      const atIndex = value.lastIndexOf('@');
      if (atIndex === -1) return null; // let email pattern validator handle malformed
      const domain = value.substring(atIndex + 1).toLowerCase();
      if (ALLOWED_EMAIL_DOMAINS.includes(domain)) return null;
      return { invalidDomain: true };
    };
  }

  passwordMatchValidator(control: AbstractControl, minChar = 4): ValidationErrors | null {
    const passwordCtrl = control.get('password');
    const confirmpasswordCtrl = control.get('confirmpassword');
    const passwordValue = passwordCtrl?.value;
    const confirmpasswordValue = confirmpasswordCtrl?.value;
    const matchPassword = control && passwordValue === confirmpasswordValue && passwordValue > 0 && confirmpasswordValue > 0;
    const noData = control && passwordValue === confirmpasswordValue && passwordValue === 0 && confirmpasswordValue === 0;
    if (!control) {
      return null;
    } else if (matchPassword) {
      return null;
    } else if (noData) {
      return null;
    } else if (passwordValue > 0 && confirmpasswordValue > 0 && passwordValue !== confirmpasswordValue) {
      return { missmatch: true };
    } else {
      return null;
    }
  }

  passwordMatchValidatorOld(c: AbstractControl): ValidationErrors | null {
    const matchPassword = c && c.get('password')?.value === c.get('confirmpassword')?.value;
    if (matchPassword) {
      c.get('password')?.setErrors(null);
      c.get('confirmpassword')?.setErrors(null);
      return null;
    } else {
      c.get('password')?.setErrors({ missmatch: true });
      c.get('confirmpassword')?.setErrors({ missmatch: true });
      return { missmatch: true };
    }
  }
}
